import { render, staticRenderFns } from "./NewsTag.vue?vue&type=template&id=0137385e&"
import script from "./NewsTag.vue?vue&type=script&lang=js&"
export * from "./NewsTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports